import { useEffect } from 'react';

export const useContentProtection = () => {
  useEffect(() => {
    // Bloquear clique direito
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // Bloquear arrastar imagens
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
    };

    // Bloquear seleção de texto/imagens
    const handleSelectStart = (e: Event) => {
      e.preventDefault();
    };

    // Bloquear atalhos de teclado
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+S (salvar página)
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();
      }
      
      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
      }
      
      // F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
      }
      
      // Ctrl+U (ver código fonte)
      if (e.ctrlKey && e.key === 'u') {
        e.preventDefault();
      }
      
      // Ctrl+Shift+C (inspecionar elemento)
      if (e.ctrlKey && e.shiftKey && e.key === 'C') {
        e.preventDefault();
      }
      
      // Ctrl+Shift+J (console)
      if (e.ctrlKey && e.shiftKey && e.key === 'J') {
        e.preventDefault();
      }
    };

    // Adicionar event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('keydown', handleKeyDown);

    // Adicionar estilos CSS para bloquear seleção
    const style = document.createElement('style');
    style.textContent = `
      * {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
      }
      
      input, textarea {
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
        user-select: text;
      }
    `;
    document.head.appendChild(style);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('keydown', handleKeyDown);
      document.head.removeChild(style);
    };
  }, []);
};
